module.exports = __webpack_public_path__ + "img/product-attr.cd6e63ef.svg";